export default function MobileMenu() {
  const header = document.querySelector('.o-header')
  const body = document.querySelector('body')
  const burgerOpen = document.querySelector('.a-button__icon.hamburger.open')
  const burgerClose = document.querySelector('.a-button__icon.hamburger.close')
  const menu = document.querySelector('.m-nav.mobile')

  if (!burgerOpen || !burgerClose || !menu) return

  burgerClose.style.display = 'none'

  const handleClick = () => {
    const isActive = menu.classList.contains('is-active')

    if (isActive) {
      menu.classList.remove('is-active')
      $(menu).fadeOut(200)

      header.classList.remove('is-active')
      body.classList.remove('is-active')

      burgerOpen.style.display = 'block'
      burgerClose.style.display = 'none'
    } else {
      menu.classList.add('is-active')
      $(menu).fadeIn(200)

      header.classList.add('is-active')
      body.classList.add('is-active')

      burgerOpen.style.display = 'none'
      burgerClose.style.display = 'block'
    }
  }
  burgerOpen.addEventListener('click', handleClick)
  burgerClose.addEventListener('click', handleClick)

  const firstLevelList = document.querySelectorAll(
    '.o-header__nav.mobile #menu-menu-1 > .menu-item-has-children'
  )

  firstLevelList.forEach((firstLvl) => {
    const link = firstLvl.querySelector('> a')
    if (!link) return

    link.addEventListener('click', (e) => {
      if (window.innerWidth < 1024) {
        e.preventDefault()
        firstLvl.classList.toggle('active')
      }
    })
  })

  const secondLevelList = document.querySelectorAll(
    '.o-header__nav.mobile #menu-menu-1 > .menu-item-has-children > ul > .menu-item-has-children'
  )

  secondLevelList.forEach((secondLvl) => {
    const link = secondLvl.querySelector('> a')
    if (!link) return

    link.addEventListener('click', (e) => {
      e.preventDefault()
      secondLvl.classList.toggle('active')
    })
  })

  const thirdLevelList = document.querySelectorAll(
    '.o-header__nav.mobile #menu-menu-1 > .menu-item-has-children > ul > .menu-item-has-children > ul > .menu-item-has-children'
  )

  thirdLevelList.forEach((thirdLvl) => {
    const link = thirdLvl.querySelector('> a')
    if (!link) return

    link.addEventListener('click', (e) => {
      e.preventDefault()
      thirdLvl.classList.toggle('active')
    })
  })
}
